import {http} from '@/http'

const resource = "/api/auth";
const cpResource = "/portal/api";
const userResource = "/api/user";

export default {
    get() {
        return http.get(`${resource}`);
    },
    getUser(userId) {
        return http.get(`${resource}/${userId}`);
    },
    createUser(payload) {
        return http.post(`${resource}`, payload);
    },
    registerUser(payload) {
        return http.post(`${resource}/register/`, payload)
    },
    registerParentConsent(payload){
        return http.post(`${resource}/parentconsent/`, payload)
    },
    activateAccount(authentication_token, authentication_code, password) {
        return http.post(`${cpResource}/customer/activate/`, {
                authentication_token: authentication_token,
                authentication_code: authentication_code,
                password: password
            })
            .then(response => {
                    return response
                }
            ).catch(err => {
            });
    },
    changePasswordRequest(email) {
        return http.post(`${resource}/ForgetPassword/`, { email: email })
    },
    changePassword(payload) {
        return http.post(`${resource}/ResetPassword/`, payload)
    },
    saveSettings(payload) {
        return http.post(`${resource}/settings/`, payload)
    },
    changeUserPassword(payload) {
        return http.post(`${userResource}/changepassword/`, payload)
    },
    sendConfirmationEmail(email) {
        return http.post(`${resource}/sendConfirmationEmail/`, { email: email })
    },
}